import React from 'react';
import ReactDOM from 'react-dom';
import { Route, Router, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
import { syncHistoryWithStore } from 'react-router-redux';
import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { CookiesProvider } from 'react-cookie';
import { createBrowserHistory } from 'history';
import '@fontsource/inter';
import '@fontsource/roboto';
import './index.scss';
import './utils/i18n';
import { BASENAME } from './utils/constants';
import reducer from './redux/reducer';
import App from './containers/App';
import { ThemeContextProvider } from './context/ThemeContextProvider';

const store = configureStore({
	reducer,
	getDefaultMiddleware,
	devTools: process.env.NODE_ENV !== 'production'
});

export const history = syncHistoryWithStore(createBrowserHistory({ basename: BASENAME }), store);

ReactDOM.render(
	<CookiesProvider>
		<ThemeContextProvider>
			<Provider store={store}>
				<Router history={history} basename={BASENAME}>
					<Switch>
						<Route path="/" component={App} />
					</Switch>
				</Router>
			</Provider>
		</ThemeContextProvider>
	</CookiesProvider>,

	document.getElementById('root')
);
